import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef } from 'react';
import { useDatePickerPopper } from './useDatePickerPopper';
import { useControlledFlagState } from '../../../system/hooks/useControlledFlagState';
import { useInternalRef } from '../../../utils';
import { useOverlay } from '../../../system/hooks/useOverlay';
import { useOuterClick } from '../../../system/hooks/useOuterClick';
export var useDatePickerPanel = function useDatePickerPanel(_ref, ref) {
  var open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      onOpenChange = _ref.onOpenChange,
      zIndex = _ref.zIndex,
      enablePortal = _ref.enablePortal,
      restProps = _objectWithoutProperties(_ref, ["open", "defaultOpen", "onOpenChange", "zIndex", "enablePortal"]);

  var _useDatePickerPopper = useDatePickerPopper(),
      dropdownRef = _useDatePickerPopper.dropdownRef,
      triggerRef = _useDatePickerPopper.triggerRef,
      dropdownProps = _useDatePickerPopper.dropdownProps,
      arrowProps = _useDatePickerPopper.arrowProps;

  var _useControlledFlagSta = useControlledFlagState(defaultOpen, open, onOpenChange),
      _useControlledFlagSta2 = _slicedToArray(_useControlledFlagSta, 5),
      reallyOpen = _useControlledFlagSta2[0],
      setClose = _useControlledFlagSta2[3],
      toggleOpen = _useControlledFlagSta2[4];

  var _useOverlay = useOverlay(reallyOpen, {
    zIndex: zIndex
  }),
      realZIndex = _useOverlay.zIndex;

  var rootRef = useRef(null);
  useInternalRef(ref, rootRef);
  useOuterClick([rootRef, dropdownRef], setClose, reallyOpen);
  return {
    rootRef: rootRef,
    inputRef: triggerRef,
    reallyOpen: reallyOpen,
    toggleOpen: toggleOpen,
    setClose: setClose,
    portalProps: {
      enablePortal: enablePortal
    },
    dropdownProps: _objectSpread(_objectSpread({}, dropdownProps), {}, {
      zIndex: realZIndex
    }),
    arrowProps: arrowProps,
    restProps: restProps
  };
};